export default __webpack_public_path__ + "static/media/profile.ee489764.png";